/**
 * @export
 * @desc Enumeration of filter keys used in the Trusted Solution module.
 */
export enum TrustedSolutionFilterKey {
  BRAND = 'brand',
  CALLER = 'caller',
  NAME = 'name',
  PERIOD = 'period',
  PRIORITY = 'priority',
  REQUEST_TYPE = 'requestType',
  STATUS = 'status',
  TITLE = 'title'
}
